// Settings state management with Zustand
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SettingsState {
  timezone: string
  
  // Actions
  setTimezone: (timezone: string) => void
  resetToDefaults: () => void
}

const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      timezone: DEFAULT_TIMEZONE,
      
      setTimezone: (timezone: string) => {
        set({ timezone })
      },
      
      resetToDefaults: () => {
        set({ timezone: DEFAULT_TIMEZONE })
      },
    }),
    {
      name: 'appstats-settings',
    }
  )
)
